import React, { useEffect } from 'react';
import { mergeDeepRight } from 'ramda';
import qs from 'qs';
import { useLocation, useNavigate } from 'react-router';
import { usePostRedirectResult } from 'Datev/hooks/settings';
import config from '../config';

const Callback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const postRedirectMutation = usePostRedirectResult();
  useEffect(() => {
    const payload = qs.parse(location.hash.slice(1));
    postRedirectMutation.mutate(
      mergeDeepRight(
        {
          redirect_url: config.appDetails.redirectUrl,
        },
        payload
      ),
      {
        onSettled: () => {
          navigate(location.pathname.replace('callback', 'home'));
        },
      }
    );
    // eslint-disable-next-line
  }, []);

  return <></>;
};
export default Callback;
